// ชื่อ system_role (backend/models/Role.js, จัดการที่ Management > RoleList) ที่ใช้กรองตัวเลือก
// "ผู้รับผิดชอบ/ผู้ประสานงาน" ในหน้า Opportunities — ให้เลือกได้เฉพาะพนักงานฝ่ายการตลาด
export const MARKETING_ROLE_NAME = 'ฝ่ายการตลาด';

export const isMarketingEmployee = (e) => (e?.system_role || []).some((r) => r?.name === MARKETING_ROLE_NAME);

// employee.rows (จาก employeeAll, populate system_role: [{_id, name}] มาแล้ว) -> เฉพาะฝ่ายการตลาด
export const filterMarketingEmployees = (rows) => (rows || []).filter(isMarketingEmployee);
